import React, { useEffect, useMemo, useState } from 'react'
import { set, useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import useFetch from '../../../../hooks/useAxios';
import Button from '../../../shared/Button';
import InputWithlabelin from '../../../shared/InputWithlabelin'

const MyWalleteShaba = () => {
  const [iban, setiban] = useState()
  const [walletInfo, setwalletInfo] = useState()

    const {
        handleSubmit,
        formState: { errors, isValid },
        control,
        reset
      } = useForm({
        defaultValues: useMemo(
          () => {
            return walletInfo;
          },
          [walletInfo]
        )
      });
      const postiban = useFetch({
        method: "post",
        url: "api/wallet/iban",
        noHeader: false,
        trigger: false,
        data:iban,
        argFunc: res => {
          toast.success("شماره ی شبای شما ذخیره شد")

          
        },
        errMessage:err=>{
          if(err.response.data.errors.iban_code){
            for(let x of err.response.data.errors.iban_code){
              toast.error(x)
            }
           
          }
        
        }
      });
      const onSubmit = (data)=>{
       // console.log("lll")
        setiban({iban_code:`IR${data.iban_code}`})
      }
      useEffect(() => {
        if(iban){
          postiban.reFetch()
        }
      }, [iban])
      const fetchwalletIban = useFetch({
        method: "get",
        url: "api/wallet/iban",
        noHeader: false,
        trigger: true,
        argFunc: res => {
          setwalletInfo(res.data.iban)
          
        }

      });
      useEffect(() => {
       if (walletInfo) {
         reset({iban_code:walletInfo})
         
       }
      }, [walletInfo])
      
  return (
    <div className='MyWalleteShaba'>
        <h6>
        کیف پول شما
        </h6>
        <p>شماره ی شبای ثبت شده می بایست به نام (( سجاد لطیفی )) ؛ در غیر این صورت واریز وجه قابل انجام نخواهد بود</p>
        <hr className='my-[30px]' />
        <form onSubmit={handleSubmit(onSubmit)} >
      <div className='flex flex-col md:flex-row-reverse items-center w-full gap-[30px] relative z-[99999]'>
        
        <InputWithlabelin
              name="iban_code"
              control={control}
              errors={errors}
              register={{
                required: "شماره شبا  مورد نظر را وارد کنید"
              }}
           
              className="seconadary-input shaba-input"
              type="number"
              labelIn="IR"
          
            />
                <Button className=" self-end" varient="secondary">ثبت شماره شبا</Button>
        </div>
      </form>
    
    </div>
  )
}

export default MyWalleteShaba